import barba from '@barba/core';
import views from './views/views';
import transitions from './transitions/transitions';

export default class Spa {
	constructor() {
		let scrollX = 0;
		let scrollY = 0;

		if (history.scrollRestoration) {
			history.scrollRestoration = 'manual';
		}

		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			const blessEvent = new CustomEvent('bless', {
				detail: {
					element: next.container,
					trigger: trigger,
				},
			});
			document.dispatchEvent(blessEvent);
		});

		barba.hooks.leave(({ current, next, trigger }) => {
			if (trigger !== 'back') {
				scrollX = barba.history.current.scroll.x;
				scrollY = barba.history.current.scroll.y;
			}
		});

		barba.hooks.enter(({ current, next, trigger }) => {
			if (trigger == 'back') {
				window.scrollTo(scrollX, scrollY);
			} else {
				window.scrollTo(0, 0);
			}
		});

		barba.hooks.after(({ current, next, trigger }) => {
			// Dot stuff like tracking, update header, etc.
		});

		// Barba settings, transitions and views
		barba.init({
			debug: window.WPURLS.env == 'development' ? true : false,
			timeout: 5000,
			requestError: (trigger, action, url, response) => {
				if ((trigger === 'back' || trigger === 'forward') && response.status && response.status === 404) {
					return true;
				}
				return false;
			},
			transitions: transitions,
			views: views,
		});
	}
}
